import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	breadcrumbs: {
		overflow: 'hidden',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		maxWidth: '100%',
		gap: theme.spacing.tiny,
	},
	breadcrumbsWrapper: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		width: '100%',
		color: theme.accoTop.link.color.default,
	},
	location: {
		color: theme.accoTop.link.color.default,
		whiteSpace: 'nowrap',

		'&:not(:last-child)::after': {
			content: '","',
			marginRight: theme.spacing.tiny,
		},
	},
}));
